/** Comparison of a ranking slot vs current consensus rank for the draft class. */
export function getConsensusComparison(mediaRank, consensusRank) {
  const media = Number(mediaRank);
  const consensus = Number(consensusRank);
  if (!Number.isFinite(media) || !Number.isFinite(consensus)) {
    return null;
  }
  return {
    consensusRank: consensus,
    /** Positive = ranked higher in this list than consensus (more bullish). */
    delta: consensus - media,
  };
}

export function formatConsensusDelta(delta) {
  if (delta == null || !Number.isFinite(delta)) return null;
  if (delta === 0) return "±0";
  return delta > 0 ? `+${delta}` : `${delta}`;
}
